import React, { useEffect, useCallback } from 'react'
import _ from 'lodash'

import { hooks } from '@front/volcanion'
import { GeoUtils, HookUtils } from '@front/volcanion/utils'
import Utils from '@front/volcanion/utils/main'

function getDisabledTypes(estimations, selectedCommercialPackage, estimation_type_dirty, estimation_type) {
  const matched_cps = _.filter(estimations, ['commercial_package_id', selectedCommercialPackage])
  const cp_estimation_types = _.uniq(_.compact(_.map(matched_cps, 'type')))
  const final_cp_types = _.uniq(_.compact(_.flatten([!estimation_type_dirty && _.isEmpty(cp_estimation_types) ? [estimation_type] : [], cp_estimation_types])))
  return _.compact(_.difference(['fixed', 'estimated'], final_cp_types))
}
function getCPIds(packages, selectedCommercialPackage, isReadOnly) {
  if (!!isReadOnly || (!!selectedCommercialPackage && _.isEmpty(packages)))
    return [selectedCommercialPackage]
  return _.compact(_.uniq(_.map(packages, 'commercial_package_id')))
}
const withContainer = Component => () => {
  const [{ dirty: estimation_type_dirty } = {}] = hooks.useFieldMeta('estimation_type')
  const [
    source_details,
    destination_details,
    selectedCommercialPackage,
    estimation_type,
    companyservice_id,
    mode,
    duration,
    requestedAt,
    application,
    commercial_formula,
    load_type,
    load_count,
    vehicle_opts,
    driver_opts,
    returnAt,
  ] = hooks.useFieldValues([
    'source',
    'destination',
    'commercial_package',
    'estimation_type',
    'user.companyservice',
    'ridemode',
    'ridemode_duration',
    'requestedAt',
    'user.application',
    'user.commercial_formula',
    'load_type',
    'load_count',
    'vehicle_opts',
    'driver_opts',
    'returnAt',
  ])
  const voucher_id = hooks.useFormStateValue('voucher_id')

  const setFormValues = hooks.useFormChange()
  const { initialValues } = hooks.useFormProps()
  const isReady = hooks.useFormStatus('isReady')
  const isReadOnly = hooks.useFormStateValue('isReadOnly')
  const [isManagingRecord] = hooks.useFormState('isManagingRecord')
  const [{ selected_user, user_id }] = hooks.useFormState()
  const owner = selected_user || user_id

  const estimation_filter = {
    service: companyservice_id,
    user_id: owner,
    requestedAt,
    source_details,
    destination_details,
    mode,
    duration,
    vehicle_opts,
    driver_opts,
    returnAt,
    load_type,
    load_count,
    application,
    commercial_formula,
    voucher_id
  }
  const [, , , { refreshEstimate: refreshDriverEstimate }] = hooks.useEstimation(estimation_filter, {
    isReady,
    disabled: isReadOnly,
    disable_destination_validate: true,
    disable_planned_delay: !!isManagingRecord,
    listener_id: 'driver_estimations',
    estimation_class: 'driver'
  })

  const [estimations, packages, status, { refreshEstimate }] = hooks.useEstimation(estimation_filter, {
    isReady,
    disabled: isReadOnly,
    disable_destination_validate: true,
    disable_planned_delay: !!isManagingRecord,
    listener_id: 'package_estimations',
    estimation_class: 'customer'
  })

  const cp_ids = getCPIds(packages, selectedCommercialPackage, isReadOnly)

  const { isEstimationLoading, isEstimationFetched } = status

  const disabled_types = getDisabledTypes(estimations, selectedCommercialPackage, estimation_type_dirty, estimation_type)
  const estimation_ready = _.isEmpty(estimations) || disabled_types.length === 3 || !!HookUtils.getLoadingState([status])
  const hideEstimationType = !!isManagingRecord ? (!!isEstimationFetched && !!estimation_ready) : !!estimation_ready
  const hideRefreshEstimate = !!isManagingRecord ? !!isEstimationLoading || !!isReadOnly : !!estimation_ready
  const isLoading = status?.isAuthorizedLoading
  const refreshEstimations = useCallback(() => Promise.all([refreshEstimate(), refreshDriverEstimate()]), [refreshEstimate, refreshDriverEstimate])

  useEffect(() => {
    if (!isReadOnly && !isEstimationLoading && !!destination_details)
      setFormValues([{ field: 'estimation_type', value: initialValues?.estimation_type }])
  }, [
    Utils.selectFirstKey(source_details, GeoUtils.getAddressKeys()),
    Utils.selectFirstKey(destination_details, GeoUtils.getAddressKeys())
  ])

  const mergedProps = {
    mode,
    cp_ids,
    isLoading,
    hideEstimationType,
    disabled_types,
    refreshEstimations,
    hideRefreshEstimate
  }
  return (
    <Component {...mergedProps} />
  )
}
export default withContainer
